import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import CopyIcon from '@/assets/icons/copy.svg?react';
import { useToast } from '@/hooks/useToast';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly text: string;
}

export const CopyableField: React.FC<Props> = (props: Props): React.ReactElement => {
  const { text } = props;
  const toast = useToast();
  const tr = useTranslator();

  const onCopy = React.useCallback((): void => {
    navigator.clipboard.writeText(text).then(
      (): void => {
        toast.show(tr('COPIED'), 'success');
      },
      (): void => {
        toast.show(tr('AN_ERROR_OCCURRED'), 'error');
      },
    );
  }, [text, toast, tr]);

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
      <Typography variant="body2">{text}</Typography>
      <IconButton color="inherit" size="medium" onClick={onCopy}>
        <CopyIcon fill="currentColor" width={16} height={16} />
      </IconButton>
    </Stack>
  );
};
